import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { callPostApiWithoutAuth } from "../api/ApiCaller";
import { PLAYER_LOGIN_URL } from "../api/ApiConst";
import { STATUS } from "../utils/Constants";
import { BLAUTHTOKEN, CURRENCY_CODE, getDataFromStore, setDataInStore } from "../utils/CookiesUtils";
import toast from "react-hot-toast";

const recordObj = {
    username: "",
    password: ""
}

const LoginScreen = () => {
    const navigate = useNavigate();
    const [record, setRecord] = useState({ ...recordObj });
    const token1 = getDataFromStore(BLAUTHTOKEN);
    const _token = token1 ? token1 : "";
    const [loginToken, setLoginToken] = useState(_token);
    const [showPassword, setShowPassword] = useState(false)

    const handleLogin = (e) => {
        if (record.username === null || record.username.length === 0) {
            toast.error("Please provide username!", { id: "loginData" });
            return;
        }
        if (record.password === null || record.password.length === 0) {
            toast.error("Please provide password!", { id: "loginData" });
            return;
        }
        e.preventDefault();
        callPostApiWithoutAuth(PLAYER_LOGIN_URL, record, (response) => {
            if (response.errorCode === STATUS.SUCCESS) {
                const token = response?.responsePacket;
                setLoginToken(token.secreteKey);
                setDataInStore(BLAUTHTOKEN, token.secreteKey);
                setDataInStore(CURRENCY_CODE, token.currencyShortCode ?? "USD");
                navigate("/");
            } else {
                if (response.success === false) {
                    if (response.errorCode === 998) {
                        toast.error(response.message);
                    }
                } else {
                    toast.error(e.message);
                }
            }
        }, (error) => {
            console.error(error)
        })
    };
    const handleRegister = () => {
        navigate("/register");
    };
    const handlePassword = () => {
        navigate("/forgetpassword");
    };

    const handleTextChange = (e) => {
        const { value, name } = e.target;
        setRecord((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const toggleVisibility = () => {
        setShowPassword(!showPassword)
    }

    return (
        <div className="main-content">
            <div className="container-fluid">
                <div className="row justify-content-center login-content">
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-9 col-12 text-center">
                        <img
                            src="assets/img/logo.png"
                            alt="logo"
                            className="img-fluid lw-sm"
                        />
                        <form className="lb-box mt-3" onSubmit={handleLogin}>
                            <div className="input-group">
                                <span className="input-group-text" id="Account">
                                    <i className="fa fa-user" aria-hidden="true"></i>
                                </span>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="username"
                                    placeholder="Username"
                                    aria-label="Username"
                                    aria-describedby="username"
                                    value={record.username}
                                    onChange={handleTextChange}
                                />
                            </div>
                            <div className="input-group mt-lg-3 mt-md-3 mt-2">
                                <span className="input-group-text" id="password">
                                    <i className="fa fa-lock" aria-hidden="true"></i>
                                </span>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    className="form-control"
                                    name="password"
                                    placeholder="Password"
                                    aria-label="Password"
                                    aria-describedby="password"
                                    value={record.password}
                                    onChange={handleTextChange}
                                />
                                <span className="input-group-text password-toggle-icon" onClick={toggleVisibility}>
                                    <i className={showPassword ? "fa fa-eye" : "fa fa-eye-slash"} aria-hidden="true"></i>
                                </span>
                            </div>

                            <button
                                type="submit"
                                className="w-100 cursor-pointer btn-outer border-0 mt-lg-4 mt-md-3 mt-3 mb-1"
                            >
                                <span className="btn-inner">Login</span>
                            </button>
                            {/* <span
                                onClick={handlePassword}
                                className="cursor-pointer text-white h6 text-decoration-underline"
                            >
                                I forgot my password.{" "}
                            </span> */}
                            <button
                                className="w-100 cursor-pointer btn-outer border-0 mt-3 mb-lg-2 mb-md-2 mb-1"
                                onClick={handleRegister}
                            >
                                <span className="btn-inner bg-blue">Create Account</span>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginScreen;
